
const AddIcon = (props:any) => {
  return (
    <svg
      id="add_2_"
      data-name="add (2)"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 26.423 26.423"
      {...props}
    >
      <g id="Group_56566" data-name="Group 56566">
        <g id="Group_56565" data-name="Group 56565">
          <path
            id="Path_59375"
            data-name="Path 59375"
            d="M13.211,0A13.211,13.211,0,1,0,26.423,13.211,13.226,13.226,0,0,0,13.211,0Zm0,24.536A11.324,11.324,0,1,1,24.536,13.211,11.337,11.337,0,0,1,13.211,24.536Z"
            fill="#fff"
          />
        </g>
      </g>
      <g
        id="Group_56568"
        data-name="Group 56568"
        transform="translate(12.14 6.069)"
      >
        <g id="Group_56567" data-name="Group 56567">
          <path
            id="Path_59376"
            data-name="Path 59376"
            d="M238.785,134.1a1.071,1.071,0,0,0-1.071,1.071v12.143a1.071,1.071,0,1,0,2.143,0V135.166A1.071,1.071,0,0,0,238.785,134.1Z"
            transform="translate(-237.714 -134.095)"
            fill="#fff"
          />
        </g>
      </g>
      <g
        id="Group_56570"
        data-name="Group 56570"
        transform="translate(6.069 12.14)"
      >
        <g id="Group_56569" data-name="Group 56569">
          <path
            id="Path_59377"
            data-name="Path 59377"
            d="M147.309,237.714H135.166a1.071,1.071,0,0,0,0,2.143h12.143a1.071,1.071,0,1,0,0-2.143Z"
            transform="translate(-134.095 -237.714)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
export default AddIcon;
